﻿window.cExcel = function(pathNameFile) {
    var Me = this;
    this.pathNameFile = pathNameFile
    this.workbook = null;

    this.mLoad = function (funcEndLoad) {
        var reader = new FileReader();

        reader.onload = function (e) {
            var data = e.target.result;
            try { Me.workbook = XLSX.read(data, { type: 'binary' }); }
            catch (e) { }
            if (typeof funcEndLoad != 'undefined') funcEndLoad(Me)
        };

        reader.onerror = function (ex) {
            if (typeof funcEndLoad != 'undefined') funcEndLoad(Me)
        };

        reader.readAsBinaryString(pathNameFile);
    }

    this.mGetDataJson = function (sheetName) {
        return XLSX.utils.sheet_to_row_object_array(Me.workbook.Sheets[sheetName]);
    }

}